var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS6P1BB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 148,
    viewBox: "0 0 196 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2063_319",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -96,
    y: 0,
    width: 292,
    height: 148
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196 0H-96V148H196V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2063_319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196 74.7939V107.993C171.578 131.229 102.221 147.977 20.4983 147.977C-9.29348 148.092 -39.0411 145.676 -68.4239 140.757L-96 134.908V101.732C-64.1955 109.9 -23.66 114.79 20.4983 114.79C102.221 114.79 171.578 98.0307 196 74.8054",
    fill: "#B7AAA3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1148 53.6022C100.621 55.59 151.796 68.762 163.67 85.7726C165.319 83.5816 166.238 80.9282 166.298 78.1869C166.298 57.8176 110.803 41.0127 39.0804 38.5108L41.366 21.2603C116.632 24.1164 177.189 42.1209 191.314 65.3919C193.307 62.2725 194.394 58.662 194.457 54.9617C194.457 24.6419 116.54 0 20.5326 0V53.2937L37.1148 53.6022Z",
    fill: "#B7AAA3",
    fillOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS6P1BB);
export default __webpack_public_path__ + "static/media/HomeS6P1B-B.7aa5c49242fbbb0a21a47b51b9f895b2.svg";
export { ForwardRef as ReactComponent };